import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import React from 'react';

import { GapMapPDF, ThreatModelingPDF, TrainingPDF } from '@/assets';
import { muiPalette } from '@/shared/general-theme';

const services = [
  {
    title: 'Gap Analysis',
    tag: 'Strategic',
    description: 'Comprehensive security gap analysis to identify areas for improvement in your security program.',
    pdfUrl: GapMapPDF,
  },
  {
    title: 'Threat Modeling',
    tag: 'Technical',
    description: 'Advanced threat modeling services to identify and mitigate potential security risks.',
    pdfUrl: ThreatModelingPDF,
  },
  {
    title: 'Security Training',
    tag: 'Enablement',
    description: 'Three-day intensive training program on threat modeling and security best practices.',
    pdfUrl: TrainingPDF,
  },
];

const ServicesSection: React.FC = () => {
  return (
    <Box>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={4}
        justifyContent='space-between'
        alignItems='flex-end'
        sx={{ mb: '3rem' }}
      >
        <Box sx={{ maxWidth: '600px' }}>
          <Typography variant='h4' sx={{ color: 'white', fontWeight: 700, mb: '1rem' }}>
            Strategic Change: <br /> From Assessment to Action
          </Typography>
          <Typography variant='body1' sx={{ color: muiPalette.grey[400] }}>
            Our expert consultants help you build resilient programs through Security Champions integration,
            policy development, and deep process enhancement.
          </Typography>
        </Box>
        <Button
          variant='outlined'
          endIcon={<ArrowForwardIcon />}
          sx={{
            color: muiPalette.grey[50],
            backgroundColor: 'transparent',
            borderColor: muiPalette.grey[600],
            fontWeight: 500,

            '&:hover': {
              backgroundColor: muiPalette.grey[900],
              borderColor: muiPalette.grey[600],
            },
          }}
        >
          View All Services (ToDo)
        </Button>
      </Stack>

      <Grid container spacing={3}>
        {services.map((service, i) => (
          <Box
            key={i}
            sx={{
              flex: 1,
              p: '2rem',
              borderRadius: '0.75rem',
              backgroundColor: muiPalette.background.dark,
              border: `1px solid ${muiPalette.border.dark}`,
              transition: 'all 0.3s',
              height: '100%',

              '&:hover': {
                borderColor: muiPalette.tertiary.main,
                transform: 'translateY(-4px)',
              },
            }}
          >
            <Typography
              variant='caption'
              sx={{ color: muiPalette.tertiary.main, fontWeight: 700, textTransform: 'uppercase' }}
            >
              {service.tag}
            </Typography>
            <Typography variant='h5' sx={{ color: 'white', mt: 1, mb: 3, fontWeight: 700 }}>
              {service.title}
            </Typography>
            <Typography
              variant='body1'
              sx={{ color: muiPalette.grey[300], mb: 4, fontSize: '1.1rem', lineHeight: 1.7 }}
            >
              {service.description}
            </Typography>
            <Button
              startIcon={<PictureAsPdfIcon />}
              sx={{
                mt: 'auto',
                color: muiPalette.grey[200],
                p: 0,
                justifyContent: 'flex-start',
                padding: 'initial',

                '&:hover': {
                  color: muiPalette.grey[100],
                  backgroundColor: 'inherit',
                },
              }}
              onClick={() => window.open(service.pdfUrl, '_blank')}
            >
              Download Program PDF
            </Button>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};

export default ServicesSection;
